// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1XmE2","content":"RecentSearches_content__yvRmm"};